module.exports = __webpack_public_path__ + "tab_tuijan_default.png?d6221893cb4a50965c3e996b921e1e3a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_tuijan_default.png
// module id = 134
// module chunks = 0